import Vue from 'vue'
import { usePluginInClient, registerComponent, registerComponentProgrammatic } from './utility'
import BaseSnackbar from '~/components/v2/Feedback/BaseSnackbar.vue'

// Pass props to ModalMessage dynamic, Inject ModalMessage to root level of DOM
function open(propsData) {
  const BaseSnackbarComponent = Vue.extend(BaseSnackbar)
  return new BaseSnackbarComponent({
    el: document.createElement('div'),
    propsData,
  })
}

const BaseSnackbarComponentProgrammatic = {
  show(params) {
    return open(params)
  },
}

const BaseSnackbarPlugin = {
  install(Vue) {
    registerComponent(Vue, BaseSnackbar)
    registerComponentProgrammatic(Vue, 'snackbar', BaseSnackbarComponentProgrammatic)
  },
}

usePluginInClient(BaseSnackbarPlugin)

export default BaseSnackbarPlugin
